/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileWord = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4 2v6H1v9h3v5h16V7.586L14.414 2zm2 15h4V8H6V4h7v5h5v11H6zM16.586 7H15V5.414zM3.523 15l-1.08-4.87h1.06l.69 3.282.87-3.015h.865l.911 2.975.683-3.243h1.032L7.476 15H6.47l-.999-3.276L4.528 15z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgFileWord as FileWord };
